/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index step-indicator to autogenerate all the components and extensions
 * Used by "prepareStepIndicators"
 */

import StepIndicator from './step-indicator/StepIndicator'
export * from './step-indicator/StepIndicator'
export default StepIndicator
